import { useQuery } from "@tanstack/react-query";
import { ProductCard } from "../components/ProductCard";
import { fetchProducts } from "../api/products";
import LoadingIcon from "../components/LoadingIcon";
import { Banner } from "../components/Banner";

export default function Home() {
  const {
    data: products,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["products"],
    queryFn: fetchProducts,
  });

  return (
    <div>
      <Banner />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {isLoading ? (
          <LoadingIcon />
        ) : (
          products &&
          products.map((p) => (
            <ProductCard
              key={p.id}
              _id={p.id}
              title={p.title}
              price={p.price}
              image={p.image}
              composition={p.composition}
              size={p.size}
              taste={p.taste}
              extra={p.extra}
            />
          ))
        )}
      </div>
    </div>
  );
}
